import { MonthlyData } from '../types';

export const calculateMonthCompletionValues = (
    data: MonthlyData | null | undefined,
    minAmount: number,
    maxAmount: number,
    minVoucher: number,
    maxVoucher: number,
    voucherValue: number,
    monthCompletionValue: number,
    maxMonths: number,
    today: Date,
) => {
    if (data) {
        const sortedRecords = data?.csmMonthlySubsOrderTotal?.sort(
            (a: { year: number; month: number }, b: { year: number; month: number }) => {
                if (a.year === b.year) {
                    return b.month - a.month;
                }
                return b.year - a.year;
            },
        );

        const hasCurrentMonthData = sortedRecords?.some(
            (record: { year: number; month: number }) =>
                record.month === today.getMonth() + 1 && record.year === today.getFullYear(),
        );
        const currentMonthData = sortedRecords?.filter((sub: { year: number; month: number }) => {
            return sub.month === today.getMonth() + 1 && sub.year === today.getFullYear();
        });
        const currentMonthTotalAmount =
            currentMonthData?.map((sub: { totalAmount: number }) => {
                return sub.totalAmount;
            })?.[0] ?? 0;
        const approxMonthTotal = parseInt(data?.approximateMonthlyTotalResponse?.currentMonthTotal ?? '0');
        let currentMonthEligibleAmount = 0;
        if (approxMonthTotal > maxAmount) {
            currentMonthEligibleAmount = maxAmount;
        } else {
            currentMonthEligibleAmount = minAmount;
        }
        const isCurrentMonthEligible = currentMonthData?.some(
            (sub: { totalAmount: number }) => sub.totalAmount >= currentMonthEligibleAmount,
        );
        const threeMonthsAgo =
            hasCurrentMonthData && isCurrentMonthEligible
                ? new Date(today.getFullYear(), today.getMonth() - (maxMonths - 1), 1)
                : new Date(today.getFullYear(), today.getMonth() - maxMonths, 1);
        let threeMonthsRecords = sortedRecords?.filter((sub: { year: number; month: number }) => {
            const subDate = new Date(sub.year, sub.month - 1);
            return subDate >= threeMonthsAgo;
        });
        threeMonthsRecords = threeMonthsRecords?.filter((sub: { promocode: string | null }) => {
            return sub.promocode === null || sub.promocode === undefined || sub.promocode === '';
        });
        if (!isCurrentMonthEligible) {
            threeMonthsRecords = threeMonthsRecords?.filter((sub: { year: number; month: number }) => {
                return !(sub.month === today.getMonth() + 1 && sub.year === today.getFullYear());
            });
        }
        const lastThreeMonths = threeMonthsRecords?.slice(0, maxMonths);
        const allMonthsAboveMaxAmount = lastThreeMonths?.every(
            (sub: { totalAmount: number }) => sub.totalAmount >= maxAmount,
        );

        const promoCodes = lastThreeMonths?.map((sub: { promocode: string | null }) => sub?.promocode);
        const isValid = !promoCodes?.some((code: string | null) => code === undefined);
        // Ensure you have at least two promo codes to compare.
        const allSamePromoCode = !isValid ? promoCodes?.every((code: string | null) => code === promoCodes[0]) : false;
        const todayMonth = isCurrentMonthEligible ? today.getMonth() : today.getMonth() - 1;
        let tier = 2;

        if (lastThreeMonths != undefined && promoCodes != undefined) {
            for (let i = 0; i < lastThreeMonths?.length; i++) {
                const currentMonthData = lastThreeMonths[i];

                const totalAmount = currentMonthData?.totalAmount;
                const todayYear = today.getFullYear();

                if (
                    lastThreeMonths[i]?.month &&
                    lastThreeMonths[i]?.month !== new Date(todayYear, todayMonth - i).getMonth() + 1
                ) {
                    return { monthCompletionValue, voucherValue };
                }

                if (
                    allSamePromoCode &&
                    (promoCodes[i] !== undefined || promoCodes[i] !== '' || promoCodes[i] !== null)
                ) {
                    return { monthCompletionValue: 0, voucherValue };
                } else {
                    if (
                        totalAmount >= minAmount &&
                        (!promoCodes[i] ||
                            promoCodes[i] === undefined ||
                            promoCodes[i] === '' ||
                            promoCodes[i] === null)
                    ) {
                        monthCompletionValue = monthCompletionValue + 1;
                        if (allMonthsAboveMaxAmount) {
                            voucherValue = maxVoucher;
                        } else {
                            if (tier === 2 && totalAmount >= maxAmount) {
                                voucherValue = maxVoucher;
                            } else {
                                voucherValue = minVoucher;
                                tier = 1;
                            }
                        }
                    } else {
                        if (totalAmount < minAmount) {
                            return { monthCompletionValue, voucherValue };
                        }
                    }
                }
            }
        }
        if ((!hasCurrentMonthData || !isCurrentMonthEligible) && voucherValue !== minVoucher) {
            if (approxMonthTotal >= maxAmount) {
                voucherValue = maxVoucher;
            } else {
                voucherValue = minVoucher;
            }
        }
        if (
            !isCurrentMonthEligible &&
            voucherValue === minVoucher &&
            monthCompletionValue < maxMonths &&
            currentMonthTotalAmount >= minAmount
        ) {
            monthCompletionValue = monthCompletionValue + 1;
        }
    }

    return { monthCompletionValue, voucherValue };
};
